import { editingConfig, VALUES_PLAIN, VALUES_NESTED } from './modes';

export var plainMode = function plainMode() {
  return editingConfig.valuesMode === VALUES_PLAIN;
};
export var nestedMode = function nestedMode() {
  return editingConfig.valuesMode === VALUES_NESTED;
};

export var fieldValue = function fieldValue() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var field = arguments[1];
  return (plainMode() ? input : input.values || {})[field];
};

export var setFieldValue = function setFieldValue(entry, field, value) {
  if (plainMode()) {
    if (entry[field] !== value) entry[field] = value;
  } else {
    if (entry.values[field] !== value) entry.values[field] = value;
  }
};

export var setFieldValues = function setFieldValues(entry) {
  var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (plainMode()) {
    for (var field in delta) {
      entry[field] = delta[field];
    }
  } else {
    for (var field in delta) {
      entry.values[field] = delta[field];
    }
  }
};